import { t } from "@/i18n-js/instance";
import { isValidURL } from "@/react/helpers/urlHelpers/isValidUrl";
import { Form } from "@circle-react-shared/uikit/Form";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface RedirectToInputProps {
  formClassName: string;
  name: string;
  translationRoot: string;
}

export const RedirectToInput = ({
  name,
  translationRoot,
  formClassName,
}: RedirectToInputProps) => (
  <>
    <Form.Item
      className={formClassName}
      name={name}
      translationRoot={translationRoot}
      placeholder={t([translationRoot, "redirect_to_placeholder"])}
      hideLabel
      hideBorder
      hideDescription
      variant="extra-bottom-margin"
      rules={{
        validate: (input: string) =>
          input === "" ||
          isValidURL(input) ||
          t([translationRoot, "errors.action.redirect_to_invalid_url"]),
        maxLength: 255,
      }}
    >
      <Form.Input data-testid="countdown-redirect_text-input" />
    </Form.Item>
    <Typography.BodyXs color="text-light">
      {t([translationRoot, "redirect_to_description"])}
    </Typography.BodyXs>
  </>
);
